<div class="th-section" [class.th-section--expanded]="isOpen">
  <div class="th-section__header" (click)="toggle()">
    <div class="th-section__meta">
      <fa-icon icon="clock-rotate-left" class="th-section__icon"></fa-icon>
      <span class="th-section__title">{{ 'traveller.history.title' | translate }}</span>
    </div>
    <button
      class="th-section__toggle-btn"
      [attr.aria-expanded]="isOpen"
      (click)="$event.stopPropagation(); toggle()">
      {{ (isOpen ? 'traveller.history.collapse' : 'traveller.history.view_more') | translate }}
      <fa-icon
        icon="chevron-down"
        class="th-section__chevron"
        [class.th-section__chevron--up]="isOpen">
      </fa-icon>
    </button>
  </div>

  <div class="th-section__body" [class.th-section__body--open]="isOpen">
    <ng-container *ngIf="isOpen">

      <div *ngIf="isLoading" class="th-panel__loading">
        <fa-icon icon="rotate-right" [spin]="true" class="th-panel__loading-icon"></fa-icon>
        <span>{{ 'traveller.history.loading' | translate }}</span>
      </div>

      <ng-container *ngIf="!isLoading && externalHistoryResponse">
        <!-- Entry / Exit events -->
        <div class="th-section" [class.th-section--expanded]="entryExitExpanded">
          <div class="th-section__header" (click)="entryExitExpanded = !entryExitExpanded">
            <div class="th-section__meta">
              <fa-icon icon="arrow-right-arrow-left" class="th-section__icon"></fa-icon>
              <span class="th-section__title">{{ 'traveller.history.entry_exit' | translate }}</span>
              <span class="th-section__badge">
                {{ entryExitEvents.length }}&nbsp;{{ 'traveller.history.records' | translate }}
              </span>
            </div>
            <button
              class="th-section__toggle-btn"
              [attr.aria-expanded]="entryExitExpanded"
              (click)="$event.stopPropagation(); entryExitExpanded = !entryExitExpanded">
              {{ (entryExitExpanded ? 'traveller.history.collapse' : 'traveller.history.view_more') | translate }}
              <fa-icon
                icon="chevron-down"
                class="th-section__chevron"
                [class.th-section__chevron--up]="entryExitExpanded">
              </fa-icon>
            </button>
          </div>

          <div class="th-section__body" [class.th-section__body--open]="entryExitExpanded">
            <ng-container *ngIf="entryExitExpanded">
              <div *ngIf="entryExitEvents.length === 0" class="th-section__empty">
                <fa-icon icon="magnifying-glass" class="mr_5"></fa-icon>
                {{ 'traveller.history.no_records' | translate }}
              </div>

              <div *ngFor="let event of entryExitEvents" class="th-record">
                <div class="th-record__row">
                  <span class="th-record__date">{{ event.date }}</span>
                  <span class="th-record__desc">{{ 'traveller.history.event.' + event.type | translate }}</span>
                  <span class="th-record__status"
                    [ngClass]="event.type === 'ENTERED_COUNTRY' ? 'th-record__status--success' : 'th-record__status--info'">
                    {{ 'traveller.history.event.' + event.type | translate }}
                  </span>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <!-- Compliance events -->
        <div class="th-section" [class.th-section--expanded]="complianceExpanded"
          [class.th-section--alert]="complianceEvents.length > 0">
          <div class="th-section__header" (click)="complianceExpanded = !complianceExpanded">
            <div class="th-section__meta">
              <fa-icon icon="shield-dog" class="th-section__icon"></fa-icon>
              <span class="th-section__title">{{ 'traveller.history.compliance' | translate }}</span>
              <span class="th-section__badge" [class.th-section__badge--alert]="complianceEvents.length > 0">
                {{ complianceEvents.length }}&nbsp;{{ 'traveller.history.records' | translate }}
              </span>
              <fa-icon
                *ngIf="complianceEvents.length > 0"
                icon="triangle-exclamation"
                class="th-section__alert-icon">
              </fa-icon>
            </div>
            <button
              class="th-section__toggle-btn"
              [attr.aria-expanded]="complianceExpanded"
              (click)="$event.stopPropagation(); complianceExpanded = !complianceExpanded">
              {{ (complianceExpanded ? 'traveller.history.collapse' : 'traveller.history.view_more') | translate }}
              <fa-icon
                icon="chevron-down"
                class="th-section__chevron"
                [class.th-section__chevron--up]="complianceExpanded">
              </fa-icon>
            </button>
          </div>

          <div class="th-section__body" [class.th-section__body--open]="complianceExpanded">
            <ng-container *ngIf="complianceExpanded">
              <div *ngIf="complianceEvents.length === 0" class="th-section__empty">
                <fa-icon icon="magnifying-glass" class="mr_5"></fa-icon>
                {{ 'traveller.history.no_records' | translate }}
              </div>

              <div *ngFor="let event of complianceEvents" class="th-record">
                <div class="th-record__row">
                  <span class="th-record__date">{{ event.date }}</span>
                  <span class="th-record__desc">{{ 'traveller.history.event.' + event.type | translate }}</span>
                </div>
                <div class="th-record__details">
                  <div *ngIf="event.user" class="th-record__detail">
                    <span class="th-record__detail-label">{{ 'traveller.history.user' | translate }}</span>
                    <span class="th-record__detail-value">{{ event.user }}</span>
                  </div>
                  <div *ngIf="event.data?.reason" class="th-record__detail">
                    <span class="th-record__detail-label">{{ 'traveller.history.reason' | translate }}</span>
                    <span class="th-record__detail-value">{{ event.data.reason }}</span>
                  </div>
                  <div *ngIf="event.data?.additionalInfo" class="th-record__detail">
                    <span class="th-record__detail-label">{{ 'traveller.history.additional_info' | translate }}</span>
                    <span class="th-record__detail-value">{{ event.data.additionalInfo }}</span>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <!-- Visa events -->
        <div class="th-section" [class.th-section--expanded]="visaExpanded">
          <div class="th-section__header" (click)="visaExpanded = !visaExpanded">
            <div class="th-section__meta">
              <fa-icon icon="passport" class="th-section__icon"></fa-icon>
              <span class="th-section__title">{{ 'traveller.history.visa' | translate }}</span>
              <span class="th-section__badge">
                {{ visaEvents.length }}&nbsp;{{ 'traveller.history.records' | translate }}
              </span>
            </div>
            <button
              class="th-section__toggle-btn"
              [attr.aria-expanded]="visaExpanded"
              (click)="$event.stopPropagation(); visaExpanded = !visaExpanded">
              {{ (visaExpanded ? 'traveller.history.collapse' : 'traveller.history.view_more') | translate }}
              <fa-icon
                icon="chevron-down"
                class="th-section__chevron"
                [class.th-section__chevron--up]="visaExpanded">
              </fa-icon>
            </button>
          </div>

          <div class="th-section__body" [class.th-section__body--open]="visaExpanded">
            <ng-container *ngIf="visaExpanded">
              <div *ngIf="visaEvents.length === 0" class="th-section__empty">
                <fa-icon icon="magnifying-glass" class="mr_5"></fa-icon>
                {{ 'traveller.history.no_records' | translate }}
              </div>

              <div *ngFor="let event of visaEvents" class="th-record">
                <div class="th-record__row">
                  <span class="th-record__date">{{ event.date }}</span>
                  <span class="th-record__desc">{{ 'traveller.history.event.' + event.type | translate }}</span>
                  <span class="th-record__status"
                    [ngClass]="event.type === 'VALIDATED' ? 'th-record__status--success' : 'th-record__status--error'">
                    {{ 'traveller.history.event.' + event.type | translate }}
                  </span>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <!-- Permit events -->
        <div class="th-section" [class.th-section--expanded]="permitExpanded">
          <div class="th-section__header" (click)="permitExpanded = !permitExpanded">
            <div class="th-section__meta">
              <fa-icon icon="id-card" class="th-section__icon"></fa-icon>
              <span class="th-section__title">{{ 'traveller.history.permits' | translate }}</span>
              <span class="th-section__badge">
                {{ permitEvents.length }}&nbsp;{{ 'traveller.history.records' | translate }}
              </span>
            </div>
            <button
              class="th-section__toggle-btn"
              [attr.aria-expanded]="permitExpanded"
              (click)="$event.stopPropagation(); permitExpanded = !permitExpanded">
              {{ (permitExpanded ? 'traveller.history.collapse' : 'traveller.history.view_more') | translate }}
              <fa-icon
                icon="chevron-down"
                class="th-section__chevron"
                [class.th-section__chevron--up]="permitExpanded">
              </fa-icon>
            </button>
          </div>

          <div class="th-section__body" [class.th-section__body--open]="permitExpanded">
            <ng-container *ngIf="permitExpanded">
              <div *ngIf="permitEvents.length === 0" class="th-section__empty">
                <fa-icon icon="magnifying-glass" class="mr_5"></fa-icon>
                {{ 'traveller.history.no_records' | translate }}
              </div>

              <div *ngFor="let permit of permitEvents" class="th-record">
                <div class="th-record__row">
                  <span class="th-record__desc">{{ 'traveller.history.permit.' + permit.permitType | translate }}</span>
                  <span class="th-record__status"
                    [ngClass]="permit.status === 'APPROVED' ? 'th-record__status--success' : permit.status === 'REJECTED' ? 'th-record__status--error' : 'th-record__status--info'">
                    {{ 'traveller.history.permit.status.' + permit.status | translate }}
                  </span>
                </div>
                <div class="th-record__details">
                  <div class="th-record__detail">
                    <span class="th-record__detail-label">{{ 'traveller.history.permit.applicationType' | translate }}</span>
                    <span class="th-record__detail-value">{{ 'traveller.history.permit.appType.' + permit.applicationType | translate }}</span>
                  </div>
                  <div *ngIf="permit.issueDate" class="th-record__detail">
                    <span class="th-record__detail-label">{{ 'traveller.history.permit.issueDate' | translate }}</span>
                    <span class="th-record__detail-value">{{ permit.issueDate }}</span>
                  </div>
                  <div *ngIf="permit.expiryDate" class="th-record__detail">
                    <span class="th-record__detail-label">{{ 'traveller.history.permit.expiryDate' | translate }}</span>
                    <span class="th-record__detail-value">{{ permit.expiryDate }}</span>
                  </div>
                  <div *ngFor="let evt of permit.events" class="th-record__detail">
                    <span class="th-record__detail-label">{{ 'traveller.history.permit.status.' + evt.status | translate }}</span>
                    <span class="th-record__detail-value">{{ evt.dateTime }}</span>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <div *ngIf="!isLoading && !externalHistoryResponse && loaded" class="th-section__empty">
        <fa-icon icon="magnifying-glass" class="mr_5"></fa-icon>
        {{ 'traveller.history.no_records' | translate }}
      </div>

    </ng-container>
  </div>
</div>
